import React, { useState, useRef, useEffect, useMemo } from 'react';
import { FiBell } from 'react-icons/fi';
import { useAgents } from '../context/AgentContext';
import { useAuth } from '../context/AuthContext';
import NotificationsDropdown from './NotificationsDropdown';
import { sanitizeHtml } from '../services/sanitize';
import '../styles/BoschHeader.css';

const boschLogoSvg = `<svg width="108px" height="24px" viewBox="0 0 108 24" xmlns="http://www.w3.org/2000/svg">
<path id="bosch-logo-text" d="M78.19916,15.03735c0,3.46057-3.1618,5.1535-6.12445,5.1535c-3.41083,0-5.17847-1.29462-6.57263-2.96265 l2.51453-2.48962c1.07056,1.36926,2.46472,2.0415,4.0083,2.0415c1.29462,0,2.14105-0.62244,2.14105-1.56848 c0-0.99585-0.77179-1.31952-2.83813-1.74274l-0.54773-0.12451c-2.48962-0.52283-4.53113-1.91699-4.53113-4.75519 c0-3.112,2.53943-4.97925,5.87549-4.97925c2.8382,0,4.65564,1.21991,5.77594,2.48962l-2.46472,2.43988 c-0.82831-0.91748-2.00061-1.44946-3.23651-1.46893c-0.89624,0-1.91699,0.42328-1.91699,1.46893 c0,0.97095,1.07056,1.31946,2.41492,1.59332l0.54773,0.12451C75.51038,10.73029,78.24896,11.42737,78.19916,15.03735z M64.80499,11.92529c0,4.65558-2.66394,8.29047-7.26971,8.29047c-4.58093,0-7.26971-3.63489-7.26971-8.29047 c0-4.63068,2.68878-8.29047,7.26971-8.29047C62.14105,3.63483,64.80499,7.29462,64.80499,11.92529z M60.92114,11.92529 c0-2.46472-1.1452-4.48132-3.38586-4.48132s-3.36102,1.9917-3.36102,4.48132s1.12036,4.50623,3.36102,4.50623 S60.92114,14.43982,60.92114,11.92529z M87.06226,16.43152c-1.74274,0-3.56018-1.44397-3.56018-4.60583 c0-2.81323,1.69293-4.38171,3.46057-4.38171c1.39423,0,2.21576,0.64728,2.8631,1.76764l3.18671-2.11621 c-1.59338-2.41492-3.48547-3.43567-6.09961-3.43567c-4.78009,0-7.36926,3.70953-7.36926,8.19086 c0,4.70544,2.86304,8.39008,7.31946,8.39008c3.13696,0,4.63074-1.09546,6.24902-3.43567l-3.21167-2.16602 C89.25311,15.68463,88.55603,16.43152,87.06226,16.43152z M48.97095,15.46057c0,2.66388-2.43982,4.40662-4.92944,4.40662H35.9502 V4.0332h7.44397c2.8382,0,4.9046,1.44397,4.9046,4.35681c0.01666,1.43036-0.85675,2.72058-2.19086,3.23651 C46.10791,11.65143,48.97095,12.29877,48.97095,15.46057z M39.80914,10.25726h2.83813 c0.02155,0.00134,0.04309,0.00226,0.06464,0.00269c0.81476,0.01575,1.48804-0.6319,1.50385-1.44666 c0.00342-0.0567,0.00342-0.11353,0-0.17017c-0.047-0.77802-0.71576-1.37061-1.49377-1.32361h-2.88794L39.80914,10.25726z M44.76349,14.98755c0-0.92114-0.67218-1.54358-2.09131-1.54358h-2.81323v3.11206h2.88794 C43.91699,16.55603,44.76349,16.13275,44.76349,14.98755z M103.64313,4.03326v5.82568H98.8382V4.03326h-4.15771v15.83398h4.15771 v-6.24896h4.80493v6.24896h4.15771V4.03326H103.64313z"/>
<path id="bosch-logo-anker" d="M12,0C5.37256,0,0,5.37256,0,12c0,6.62738,5.37256,12,12,12s12-5.37262,12-12C23.99646,5.37402,18.62598,0.00354,12,0z M12,22.87964C5.99133,22.87964,1.12036,18.00867,1.12036,12S5.99133,1.1203,12,1.1203S22.87964,5.99133,22.87964,12 C22.87354,18.0061,18.0061,22.87354,12,22.87964z M19.50293,7.05475c-0.66852-1.01306-1.53552-1.88-2.54858-2.54852h-0.82159 v4.10785H7.89209V4.50623H7.04565c-4.13873,2.73114-5.27972,8.30029-2.54858,12.43896 c0.66852,1.01306,1.53552,1.88007,2.54858,2.54858h0.84644v-4.10791h8.24066v4.10791h0.82159 C21.09308,16.76257,22.23407,11.19348,19.50293,7.05475z M6.74689,17.87549c-3.24493-2.88354-3.5379-7.85168-0.65436-11.09668 c0.20508-0.23077,0.42358-0.44928,0.65436-0.65436V17.87549z M16.13275,14.24066H7.89209V9.73444h8.24066V14.24066z M17.84827,17.25549c-0.18768,0.2088-0.38629,0.40747-0.59515,0.59509v-2.48962V8.61407V6.12445 C20.49121,9.03387,20.75763,14.0174,17.84827,17.25549z"/>
</svg>`;

/**
 * Corporate Bosch Header (o-header pattern from frontend.kit)
 * Implements the full header (not minimal) with supergraphic, logo, quicklinks, and navigation.
 */
function initials(name) {
  if (!name) return 'U';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function BoschHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeNav, setActiveNav] = useState(null);
  const [showNotif, setShowNotif] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const notifRef = useRef(null);
  const profileRef = useRef(null);
  const { agents, notifications } = useAgents();
  const { user, logout } = useAuth();
  const unreadCount = notifications.filter(n => !n.read).length;
  const cleanLogoSvg = useMemo(() => sanitizeHtml(boschLogoSvg), []);
  const userInitials = useMemo(() => initials(user?.full_name || user?.email), [user]);

  useEffect(() => {
    const handleClick = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotif(false);
      if (profileRef.current && !profileRef.current.contains(e.target)) setShowProfile(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const navigation = [];

  return (
    <header className={`o-header ${menuOpen ? '-menu-open' : ''}`}>
      {/* Supergraphic bar */}
      <div className="o-header__supergraphic" />

      {/* Top bar: Logo + actions */}
      <div className="o-header__top-container">
        <div className="e-container">
          <div className="o-header__top">
            {/* Logo + Brand */}
            <div className="o-header__logo-group">
              <a
                href="/"
                className="o-header__logo"
                aria-label="Bosch Logo"
                dangerouslySetInnerHTML={{ __html: cleanLogoSvg }}
              />
              <span className="o-header__brand-name">RBIN App Launcher 2.0</span>
            </div>

            {/* Navigation links */}
            <nav className="o-header__topnav" role="navigation">
              {navigation.map((item, idx) => {
                const hasDropdown = item.isAgentDropdown || item.subNavigation.length > 0;
                return (
                  <div
                    key={idx}
                    className={`o-header__topnav-item ${activeNav === idx ? '-active' : ''}`}
                    onMouseEnter={() => hasDropdown && setActiveNav(idx)}
                    onMouseLeave={() => setActiveNav(null)}
                  >
                    <a href={item.href || '#'} className="o-header__topnav-link">
                      {item.label}
                      {item.isAgentDropdown && (
                        <span className="o-header__topnav-badge">{agents.length}</span>
                      )}
                      {hasDropdown && (
                        <span className="o-header__topnav-arrow">▾</span>
                      )}
                    </a>

                    {/* Agents mega-dropdown */}
                    {item.isAgentDropdown && activeNav === idx && (
                      <div className="o-header__agents-dropdown">
                        <div className="o-header__agents-dropdown-header">
                          <span>All Agents</span>
                          <span className="o-header__agents-dropdown-count">
                            {agents.filter(a => a.status === 'active').length} active
                          </span>
                        </div>
                        {agents.map((agent) => (
                          <a key={agent.id} href="#" className="o-header__agent-item">
                            <span className="o-header__agent-icon">{agent.icon}</span>
                            <div className="o-header__agent-info">
                              <span className="o-header__agent-name">{agent.name}</span>
                              <span className={`o-header__agent-status -${agent.status}`}>{agent.status}</span>
                            </div>
                            <span className="o-header__agent-tasks">{agent.tasksCompleted} tasks</span>
                          </a>
                        ))}
                      </div>
                    )}

                    {/* Regular dropdown */}
                    {!item.isAgentDropdown && item.subNavigation.length > 0 && activeNav === idx && (
                      <ul className="o-header__topnav-dropdown">
                        {item.subNavigation.map((sub, si) => (
                          <li key={si}>
                            <a href="#" className="o-header__topnav-dropdown-link">{sub.label}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </nav>

            {/* Notifications + User Profile — only shown when authenticated */}
            {user && (
              <div className="o-header__actions">
                <div className="o-header__notif-wrapper" ref={notifRef}>
                  <button
                    className="o-header__action-btn"
                    title="Notifications"
                    onClick={() => setShowNotif(!showNotif)}
                  >
                    <FiBell size={18} />
                    {unreadCount > 0 && <span className="o-header__notif-badge">{unreadCount}</span>}
                  </button>
                  {showNotif && <NotificationsDropdown onClose={() => setShowNotif(false)} />}
                </div>
                <div className="o-header__profile-wrapper" ref={profileRef}>
                  <button
                    className="o-header__user-avatar"
                    title={user.full_name || 'Profile'}
                    onClick={() => setShowProfile(p => !p)}
                    aria-expanded={showProfile}
                    aria-haspopup="true"
                  >
                    <span>{userInitials}</span>
                  </button>
                  {showProfile && (
                    <div className="o-header__profile-dropdown">
                      <div className="o-header__profile-info">
                        <span className="o-header__profile-name">{user.full_name || user.ntid || 'User'}</span>
                        {user.email && <span className="o-header__profile-email">{user.email}</span>}
                      </div>
                      <div className="o-header__profile-divider" />
                      <button className="o-header__profile-signout" onClick={logout}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                          <polyline points="16 17 21 12 16 7"/>
                          <line x1="21" y1="12" x2="9" y2="12"/>
                        </svg>
                        Sign Out
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Menu trigger (mobile) */}
            <button
              className="o-header__menu-trigger"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              <span className={`o-header__hamburger ${menuOpen ? 'open' : ''}`}>
                <span /><span /><span />
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
